import { QuestionnaireResult } from '../../../../../graphql/graphql';
import { ACER_GROUP_KEY_MAP, ACER_MAP } from '../Assets/acer.const';

export interface AcerGroupScoreRow {
	id: string;
	title: string;
	score: number;
	maxScore: number;
}

export const getAcerGroupScores = (
	item: QuestionnaireResult,
): AcerGroupScoreRow[] => {
	const resultItems = item.questionnaireResultItems || [];

	const groups = resultItems.reduce<Record<string, AcerGroupScoreRow>>(
		(acc, resultItem) => {
			const questionId = resultItem.questionId || '';
			const acerConfig = ACER_MAP[questionId];

			if (!acerConfig?.groupKey || acerConfig.maxScore === null) {
				return acc;
			}

			const groupKey = acerConfig.groupKey;

			if (!acc[groupKey]) {
				acc[groupKey] = {
					id: groupKey,
					title: ACER_GROUP_KEY_MAP[groupKey],
					score: 0,
					maxScore: 0,
				};
			}

			acc[groupKey].score += Number(resultItem.score ?? 0);
			acc[groupKey].maxScore += acerConfig.maxScore;

			return acc;
		},
		{},
	);

	return (
		Object.keys(ACER_GROUP_KEY_MAP) as Array<keyof typeof ACER_GROUP_KEY_MAP>
	)
		.map(groupKey => groups[groupKey])
		.filter((group): group is AcerGroupScoreRow => Boolean(group));
};

export enum AcerScoreLevel {
	NORMAL = 'normal',
	BORDERLINE = 'borderline',
	DEMENTIA = 'dementia',
}

export const ACER_SCORE_LEVEL_COLORS: Record<AcerScoreLevel, string> = {
	[AcerScoreLevel.NORMAL]: '#2E7D32',
	[AcerScoreLevel.BORDERLINE]: '#616161',
	[AcerScoreLevel.DEMENTIA]: '#000000',
};

export const getAcerScoreLevel = (percent: number): AcerScoreLevel => {
	if (percent >= 88) {
		return AcerScoreLevel.NORMAL;
	}
	if (percent >= 84) {
		return AcerScoreLevel.BORDERLINE;
	}
	return AcerScoreLevel.DEMENTIA;
};

export const getAcerTotalMaxScore = (): number =>
	Object.values(ACER_MAP).reduce((total, item) => {
		return total + (item.maxScore ?? 0);
	}, 0);

export const getAcerScorePercent = (
	score?: number | null,
	maxScore?: number | null,
): number => {
	if (!score || !maxScore) return 0;

	return (score / maxScore) * 100;
};
